<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Кандидаты выборов КСА </span>
      </div>
      <v-btn
        @click="goToCreate"
        style="width: auto !important"
        class="button-accept"
      >
        Добавить кандидата
      </v-btn>
    </div>

    <div v-if="items?.length > 0">
      <v-data-table
        :headers="tableHeaders"
        :items="items"
        item-key="id"
        :show-select="false"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <template v-slot:body="props">
          <draggable
            :list="props.items"
            tag="tbody"
            @end="endDrag"
            :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''"
          >
            <tr v-for="(item, index) in props.items" :key="index">
              <td>
                <v-icon
                  small
                  style="cursor: pointer"
                  :disabled="moveItems ? true : false"
                >
                  mdi-menu
                </v-icon>
              </td>
              <td>{{ index + 1 }}</td>
              <td>
                {{ getFullName(item) }}
              </td>
              <td>
                {{ phoneFormatRu(item.phoneNumber) }}
              </td>
              <td
                style="cursor: pointer"
                class="text-left"
                @click="goToDetail(item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </div>
    <v-divider></v-divider>
    <router-view> </router-view>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    items: [],
    moveItems: false,
    selectedDrag: "",
    tableHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "Порядок отображения",
        value: "",
        sortable: false,
      },
      {
        text: "Имя кандидата",
        sortable: false,
        value: "fullName",
      },
      {
        text: "Номер телефона",
        sortable: false,
        value: "phoneNumber",
      },
      {
        text: "",
        sortable: false,
        value: "edit",
      },
    ],
  }),
  methods: {
    openInfo(e) {
      e.preventDefault();

      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    goToCreate() {
      this.$router.push({ name: "CreateCandidate" });
    },
    goToDetail(item) {
      this.$router.push({ name: "DetailCandidate", params: { id: item.id } });
    },
    getCandidates() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/ksa-election-candidates", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getFullName(item) {
      return `${item.user.lastName} ${item.user.firstName} ${item.user.middleName}`;
    },
    endDrag(evt) {
      this.moveItems = true;
      const body = {
        id: this.selectedDrag,
        sort: evt.newIndex + 1,
      };
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 + "/ksa-election-candidates/sort",
          body,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.getCandidates();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
  },
  created() {
    this.getCandidates();
  },
};
</script>
<style lang="scss" scoped></style>
